var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantillasSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "azTSh8.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,20c0-3.8,0-7.6,0-11.3,0-2.5,0-5,0-7.5C0,.4.4,0,1.2,0,11.7,0,22.1,0,32.6,0c2.1,0,4.1,0,6.2,0,.9,0,1.2.3,1.2,1.2,0,10.6,0,21.3,0,31.9,0,1.9,0,3.8,0,5.7,0,.9-.3,1.2-1.2,1.2-10.3,0-20.5,0-30.8,0s-4.5,0-6.8,0c-.8,0-1.2-.4-1.2-1.2C0,32.5,0,26.3,0,20ZM1.9,38.1h36.1V7.6H1.9v30.4ZM38.1,1.9H1.9v3.8h36.1V1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,16.2c-4.7,0-9.3,0-14,0-.9,0-1.2-.3-1.2-1.2,0-1.1,0-2.2,0-3.4,0-.7.4-1.1,1.1-1.1,7.9,0,15.8,0,23.7,0,1.5,0,3,0,4.5,0,.8,0,1.1.4,1.1,1.1,0,1.2,0,2.3,0,3.5,0,.8-.4,1.1-1.1,1.1-2.8,0-5.6,0-8.4,0-1.9,0-3.8,0-5.7,0,0,0,0,0,0,0ZM33.3,12.4H6.7v1.9h26.6v-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.8,26.7c0-2.2,0-4.3,0-6.5,0-1.3.8-2.1,2.1-2.1,3.4,0,6.7,0,10.1,0,1.3,0,2.1.7,2.1,2,0,4.4,0,8.8,0,13.2,0,1.1-.8,1.9-1.9,1.9-3.5,0-7,0-10.4,0-1.1,0-1.9-.8-1.9-1.9,0-2.2,0-4.4,0-6.6ZM17.1,33.3v-13.3H6.7v13.3h10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.2,26.7c0,2.1,0,4.3,0,6.4,0,1.3-.8,2.1-2.1,2.1-3.4,0-6.7,0-10.1,0-1.3,0-2.1-.8-2.1-2.1,0-3.8,0-7.5,0-11.3,0-.8,0-1.5,0-2.2.2-1,.9-1.5,1.9-1.5,3.5,0,6.9,0,10.4,0,1.1,0,1.9.8,1.9,1.9,0,2.2,0,4.4,0,6.7ZM33.3,33.3v-13.3h-10.4v13.3h10.4Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantillasSection);
export default __webpack_public_path__ + "static/media/plantillas_section.c0bb0e822b501c247af7dac13e9d1145.svg";
export { ForwardRef as ReactComponent };